import * as THREE from 'three';
import Experience from '../Experience.js';
import { Sky } from 'three/addons/objects/Sky.js';
export default class Himmel{
    constructor(){
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
		this.renderer = this.experience.renderer

		let sky, sun;
        this.sky = sky
		this.sun = sun
		this.instance = this.renderer.instance
		let uniforms
		this.uniforms = uniforms
		this.sky = new Sky();
		this.sun = new THREE.Vector3();	
		this.pmremGenerator = new THREE.PMREMGenerator(this.renderer.instance);
		this.renderTarget;	
				
		if(this.debug.active){
			this.debugFolder = this.debug.ui.addFolder('Himmel')
		}
			
		this.setSunlight()
        this.initSky()
		this.guiChanged()
		// this.setTaklamper()
	
    }
	setSunlight() {
        this.sunLight = new THREE.DirectionalLight( 0xffffff,1.5)
        this.skygge = new THREE.AmbientLight( 0xffffff,.015 )
        this.sunLight.castShadow = true
        this.sunLight.shadow.camera.top = 150
        this.sunLight.shadow.camera.right = 150
        this.sunLight.shadow.camera.bottom = - 150
        this.sunLight.shadow.camera.left = - 150
		this.sunLight.shadow.camera.near = 1
		this.sunLight.shadow.camera.far = 500
        this.sunLight.shadow.mapSize.width = 4096;
        this.sunLight.shadow.mapSize.height = 4096;
        this.sunLight.position.set(-200, 200, -50)
		
        this.sunLight.target.position.set(0,0,80)
		this.sunLight.shadow.bias = -0.0005
		this.sunLight.shadow.normalBias = 0.0001
        this.scene.add(this.sunLight,   this.sunLight.target)

        // this.helper = new THREE.DirectionalLightHelper(this.sunLight)
        // this.scene.add(this.helper)

        if(this.debug.active){
            this.debugFolder
            .add(this.sunLight, 'intensity')
            .name('sunLightINtensity')
            .min(0)
            .max(10)
            .step(0.001)
        }
    }
        initSky() {
			this.sky = new Sky();
			this.sun = new THREE.Vector3();	
			this.sky.scale.setScalar( 450000 );
			this.scene.add( this.sky );
			this.effectController = {
			turbidity: 10,
			rayleigh: 3,
			mieCoefficient: 0.005,
			mieDirectionalG: 0.27,
			elevation: 2,
			azimuth: 180,
			// exposure: this.instance.toneMappingExposure
			};
				
			if(this.debug.active){	
				this.debugFolder.add( this.effectController, 'turbidity', 0.0, 20.0, 0.1 ).onChange( this.guiChanged() );
				this.debugFolder.add( this.effectController, 'rayleigh', 0.0, 4, 0.001 ).onChange( this.guiChanged() );
				this.debugFolder.add( this.effectController, 'mieCoefficient', 0.0, 0.1, 0.001 ).onChange( this.guiChanged() );
				this.debugFolder.add( this.effectController, 'mieDirectionalG', 0.0, 1, 0.001 ).onChange( this.guiChanged() );
				this.debugFolder.add( this.effectController, 'elevation', 0, 90, 0.1 ).onChange( this.guiChanged() );
				this.debugFolder.add( this.effectController, 'azimuth', - 180, 180, 0.1 ).onChange( this.guiChanged() );
				// this.debugFolder.add( this.effectController, 'sunLight', - 180, 180, 0.1 ).onChange( this.guiChanged() );
				// this.debugFolder.add( this.effectController, 'exposure', 0, 1, 0.0001 ).onChange( this.guiChanged );	
			}			
		}
		guiChanged(){
			this.uniforms  = this.sky.material.uniforms;
			this.uniforms[ 'turbidity' ].value = this.effectController.turbidity;
			this.uniforms[ 'rayleigh' ].value = this.effectController.rayleigh;
			this.uniforms[ 'mieCoefficient' ].value = this.effectController.mieCoefficient;
			this.uniforms[ 'mieDirectionalG' ].value = this.effectController.mieDirectionalG;
			this.phi = THREE.MathUtils.degToRad( 90 - this.effectController.elevation );
			this.theta = THREE.MathUtils.degToRad( this.effectController.azimuth );
			this.sun.setFromSphericalCoords( 1, this.phi, this.theta );
			this.uniforms[ 'sunPosition' ].value.copy( this.sun );
			if (this.renderTarget !== undefined) this.renderTarget.dispose();
			this.renderTarget = this.pmremGenerator.fromScene(this.sky);
			this.scene.environment = this.renderTarget.texture;
			// this.sunLight.position.x = Math.sin() * 500
			// this.sunLight.position.z = Math.cos() * 500			
		}			
		
		update(){
			// this.initSky.update(this.time.delta * 0.001)
			this.guiChanged()
		}
}